import {
  BudgetLegalEntityFragment,
  FinanceValueObjectsBudgetPeriodicityEnum,
  FinanceValueObjectsBudgetableTypeEnum,
} from 'generated/resources/graphql'
import { EmployeeForSelectFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type BudgetAllocationTypes = 'none' | 'equal' | 'manual'

export const budgetableByOptions = () => [
  {
    value: 'expensable',
    label: i18n.t('budgets.forms.new_budget.basic_information.expenses'),
  },
  {
    value: 'training_class',
    label: i18n.t('budgets.forms.new_budget.basic_information.trainings'),
  },
]

export type WizardData = {
  legalEntities: BudgetLegalEntityFragment[]
  legalEntityId?: number
  budgetId?: number
  success: boolean
  name: string
  description: string
  spenders: EmployeeForSelectFragment[]
  errors?: {
    [id: string]: string
  }
  effectiveFrom: string
  effectiveUntil?: string
  ownerEmployeeIds: number[]
  viewerEmployeeIds: number[]
  periodicity?: FinanceValueObjectsBudgetPeriodicityEnum
  amountCents: string
  currency: string
  allocationType: BudgetAllocationTypes
  allocatedAmountCents?: string
  budgetableBy: FinanceValueObjectsBudgetableTypeEnum
}

export type WizardDataField = keyof WizardData

export const allocationOptions = () => [
  {
    value: 'none',
    label: i18n.t('budgets.forms.new_budget.spenders.allocations.options.none'),
  },
  {
    value: 'equal',
    label: i18n.t('budgets.forms.new_budget.spenders.allocations.options.equal'),
  },
]

const validateMandatory = (field: WizardDataField, data: WizardData) => {
  const value = data[field]
  if (Array.isArray(value)) {
    return !!value.length
  }
  return !!data[field]
}

const getInvalidMandatoryFields = (mandatoryFields: WizardDataField[], data: WizardData) => {
  return mandatoryFields
    .map((field) => {
      return validateMandatory(field, data)
        ? null
        : { [field]: i18n.t('budgets.forms.errors.mandatory') }
    })
    .filter(Boolean)
}

export const validateMandatoryFIels = (mandatoryFields: WizardDataField[], data: WizardData) => {
  const invalidFields = getInvalidMandatoryFields(mandatoryFields, data)

  const getDataWithErrors = () => {
    const errors = Object.assign({}, ...invalidFields)

    return {
      ...data,
      errors,
    }
  }
  return {
    dataWithErrors: getDataWithErrors(),
    invalidFields,
  }
}
